const defaults = {
    sellers: [
        {
            city: "Seattle",
            id: "9d7552d7-84d4-5f89-ddda-46db1ce781e1",
            timezone: "America/Los_Angeles",
            key:"seattle"
        },
        {
            city:"St. Petersburg",
            id:"48a04385-9b54-dcfd-0672-96d312fd54ed",
            timezone: "America/New_York",
            key:"stpete"
        },
        {
            city: "Washington DC",
            id:"2096354e-402e-0058-2d6f-3bd048d87805",
            timezone: "America/New_York",
            key: "dc"
        }
    ],
    addonEvents: [{}],
    addonGroups: [{}],
    event_template: {
        data:[{}]
    },
    ticketTypes: [],
    venues: [],
    ticketGroups: [{

    }],
    eventSessions: {

    },
    selectedTickets: [{
        eventTemplateId: "",
        ticketTypeId: "",
        sessionId: "",  // can be null if event is all day event/no session event (EG. parking, membership)
        daySelected: "",
        qty: 0,
        selectionStage: "" // can be calendar, time window, ticket type
    }],
    selectedAddons: [{
    }],
    availableCalendar: [],
    availableSessions: [],
    cartId: {},
    cart: {
        "_total": 5,
        "cart": {
          "_count": 1,
          "_data": [
            {
              "additional_info": null,
              "cart_number": "",
              "channel_id": "",
              "expires_at": "",
              "expires_in": 0,
              "id": "",
              "identity_id": "",
              "invalid": false,
              "managed": false,
              "name": "",
              "portal_id": "",
              "seller_id": null,
              "state": ""
            }
          ],
          "_total": 1
        },
        "cart_fees": {
          "_count": 1,
          "_data": [
            {
              "cart_id": "",
              "currency_code": "",
              "gateway_id": "",
              "grand_totals": {
                "total_after_fees_price": "",
                "total_before_cartmod_price": "",
                "total_before_fees_price": "",
                "total_cartmod_amount": "0",
                "total_fee_fixed_inside": "0",
                "total_fee_fixed_outside": "",
                "total_fee_percent_inside": "0",
                "total_fee_percent_outside": "",
                "total_outstanding": "",
                "total_payments": ""
              }
            }
          ],
          "_total": 1
        },
        "cartmod": {
          "_count": 0,
          "_data": [
            
          ],
          "_total": 0
        },
        "gateway_audit": {
          "_count": 0,
          "_data": [
            
          ],
          "_total": 0
        },
        "ticket": {
          "_count": 2,
          "_data": [
            {
              "adjusted_value": "",
              "admit_email": "",
              "admit_name": "",
              "cart_id": "",
              "created_identity_id": "",
              "currency_code": "",
              "dedicated_order": false,
              "end_datetime": "",
              "event_session_id": "",
              "event_template_id": "",
              "face_value": "",
              "id": "",
              "identity_id": "",
              "portal_id": "",
              "redeemed_count": 0,
              "scan_code": "",
              "seller_id": "",
              "start_datetime": "",
              "state": "",
              "ticket_group_id": "",
              "ticket_order_id": null,
              "ticket_type_id": "",
              "timezone": "",
              "valid_from": null,
              "valid_to": null,
              "venue_id": ""
            }
          ],
          "_total": 2
        }
      },
    order: {},
    guestIdentity: {},
    triggerNextStage: false,
    stage: 0,
    fullAvailabilityPrice: [],
    fullAddonData: []
};

import Vue from 'vue';

export default {
    namespaced: true,
  
    state: defaults,
  
    mutations: {
      error (state, options) {
        state.error = Object.assign({}, defaults.error, options);
      },
  
      clear (state) {
        state = Object.assign({}, defaults);
      },

      setEventSessions(state, eventSessions) {
        state.eventSessions = eventSessions;
      },
      // Lots of logic in here, should probably be split into separate functions or 
      // handled by the components at some point.
      setEventTemplates(state, eventTemplates) {
        state.ticketTypes = eventTemplates.ticket_type._data;
        state.venues = eventTemplates.venue._data;
        
        let addonMeta = [];
        let addonEvent = [];
        let meta = eventTemplates.meta._data;
        let tmpEvents = [];
        for(let i = 0; i < meta.length; i++) {
          if(meta[i].metakey === "event_type") {
            if(meta[i].value === "addon") {
              addonMeta.push(meta[i]);
            }
          }
        }

        for(let j = 0; j < eventTemplates.event_template._data.length; j++) {
          let isAddon  = false;
          for(let idx = 0; idx < addonMeta.length; idx++) {
            if(eventTemplates.event_template._data[j].id === addonMeta[idx].resource_id) {
              addonEvent.push(eventTemplates.event_template._data[j]);
              isAddon = true;
            }
          }
          if (!isAddon) {
            tmpEvents.push(eventTemplates.event_template._data[j]);
          }
        }

        let tmpGroup = [];
        let tmpAddonGroups = [];
        for(let x = 0; x < eventTemplates.ticket_group._data.length; x++) {
          let isAddon  = false;
          for(let idx = 0; idx < addonMeta.length; idx++) {
            if(eventTemplates.ticket_group._data[x].event_template_id === addonMeta[idx].resource_id) {
              tmpAddonGroups.push(eventTemplates.ticket_group._data[x]);
              isAddon = true;
            }
          }
          if (!isAddon) {
            tmpGroup.push(eventTemplates.ticket_group._data[x]);
          }
        }

        state.ticketGroups = tmpGroup;
        state.addonGroups = tmpAddonGroups;

        state.addonEvents = addonEvent;
        state.eventTemplates = tmpEvents;

        for (let k = 0;  k < state.ticketTypes.length; k++) {
            Vue.set(state.ticketTypes[k], 'qty', 0);
        }
      },

      setTicketTypes(state, ticketTypes) {
        state.ticketTypes = ticketTypes;
      },

      setAvailableCalendar(state, availableCalendar) {
          state.availableCalendar = availableCalendar.calendar;
      },

      getAvailableSessions(state, availableSessions) {
        for(let i = 0; i < availableSessions.event_session._data.length; i++) {
          availableSessions.event_session._data[i].selected = false;
        }
        state.availableSessions = availableSessions.event_session._data;
      },

      inAppSetAvailableSessions(state, sessions) {
        state.availableSessions = sessions;
      },

      setCartId(state, cartId) {
        state.cartId = cartId;
      },

      setGuestIdentity(state, guestIdentity) {
          state.guestIdentity = guestIdentity;
      },

      setCart(state, cart) {
          state.cart = cart;
      },
      
      setOrder(state, order) {
          state.order = order;
      },
      setStage(state, stg) {
        state.stage = stg;
      },
      triggerNextStage(state) {
        state.triggerNextStage = true;
      },
      resetStageTrigger(state) {
        state.triggerNextStage = false;
      },
      setFullAvailabilityPrice(state, data) {
        state.fullAvailabilityPrice = data;
      },
      setFullAddonData(state, data) {
        state.fullAddonData = data;
      }

    },
  
    actions: {
      clear ({ state, commit, rootState, dispatch }) {
        commit('clear');
      },

      updateEventSessions ({ commit }, eventSessions) {
        commit('setEventSessions', eventSessions);
      },

      updateAvailableCalendar({ commit }, calendar) {
          commit('setAvailableCalendar', calendar);
      },

      updateAvailableSessions({ commit }, sessions) {
        commit('getAvailableSessions', sessions);
      },

      setAvailableSessions({commit}, sessions) {
        commit('inAppSetAvailableSessions', sessions);
      },

      updateEventTemplates ({ commit }, eventTemplates) {
        commit('setEventTemplates', eventTemplates);
      },

      updateTicketTypes ({ commit }, ticketTypes) {
        commit('setTicketTypes', ticketTypes);
      },

      updateCart ({ commit }, cart) {
        commit('setCart', cart);
      },
      updateCartId ({ commit }, cart) {
        commit('setCartId', cart);
      },

      resetCart({commit}) {
          commit('setCart', {});
      }, 

      updateOrder({ commit }, order) {
        commit('setOrder', order);
      },

      updateGuestIdentity({commit}, identity) {
        commit('setGuestIdentity', identity);
      },
      triggerNextStage({commit}) {
        commit('triggerNextStage');
      },
      resetStageTrigger({commit}) {
        commit('resetStageTrigger');
      },
      setStage({ commit }, stg) {
        commit('setStage', stg);
      },
      setFullAvailabilityPrice({ commit }, data) {
        commit('setFullAvailabilityPrice', data);
      },
      setFullAddonData({ commit }, data) {
        commit('setFullAddonData', data);
      }
    }
}